import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { StepperOfferComponent } from './stepper-offer/stepper-offer.component';
import { StepperComponent } from './stepper/stepper.component';

@NgModule({
  declarations: [StepperComponent, StepperOfferComponent],
  imports: [CommonModule, TranslateModule.forChild(), NgbProgressbarModule],
  exports: [StepperComponent, StepperOfferComponent],
})
export class StepperModule {}
